import { clsx } from "clsx";
import type { LucideIcon } from "lucide-react";

export interface ViewToggleOption<V extends string> {
	value: V;
	label: string;
	icon: LucideIcon;
}

export function ViewToggle<V extends string>({
	options,
	value,
	onChange,
}: {
	options: ViewToggleOption<V>[];
	value: V;
	onChange: (view: V) => void;
}) {
	return (
		<div className="view-toggle">
			{options.map((option) => {
				const Icon = option.icon;
				return (
					<button
						key={option.value}
						type="button"
						onClick={() => onChange(option.value)}
						aria-pressed={value === option.value}
						className={clsx(
							"view-toggle__button",
							value === option.value && "is-active",
						)}
					>
						<Icon />
						{option.label}
					</button>
				);
			})}
		</div>
	);
}
